module.exports = __webpack_public_path__ + "static/details-14-55f0277190188c6150e187e03a70a252.jpg";